import { FC, ReactNode } from 'react'

const PageTitle: FC<PageTitleComponentProps> = (props): ReactNode => {
    const { title } = props

    return (
        <div className='w-full py-2.5'>
            <div className='flex-row items-center justify-between border-[#424242] border-b flex pb-2'>
                <h1 className='font-bold text-2xl text-[#EBEBEB]'>
                    {title}
                </h1>
            </div>
        </div>
    )
}

export default PageTitle
